import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { HttpResponse, HttpParams } from '@angular/common/http';
import { IFetchDetail } from './fetch-entity.interface';

export abstract class EntityDetailResolver<TService extends IFetchDetail, TDetail> implements Resolve<TDetail> {
  constructor(
    private service: TService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.params.id;
    return this.service.getDetail(id);
  }
}
